export const themeToken = {
  components: {
    Timeline: {
      tailColor: "turquoise",
    },
  },
};
